import Render from '@Views/components/frame/input-action-frame.html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Common } from '@Models/index'

@Render
@Component({})
export class InputActionFrame extends Vue {

    private random: string = ''

    @Prop({default: false}) errorTest: boolean
    @Prop({default: false}) readonly: boolean
    @Prop({default: false}) disabled: boolean
    @Prop({default: false}) loading: boolean
    @Prop({default: true}) randomId: boolean
    @Prop({default: "text"}) type: string
	@Prop({ default: 'magic' }) icon: string
    @Prop() id: string
    @Prop() label: string
    @Prop() placeholder: string
    @Prop() title: string
    @Prop() errorMsg: string
    @Prop() value: any
    @Prop() buttonLabel: string
    @Prop() buttonTitle: string

    get displayError(): boolean {
        return this.errorTest && !!this.errorMsg
    }
    get inputId() {
        return this.randomId ? `${this.random}-${this.id}` : this.id
    }

	get iconHref(): string {
		return `${require('@Assets/svg/symbol-defs.svg')}#${this.icon}`
	}

    created() {
        this.random = Common.generateId()
    }

    handleInput(e: any): void {
        this.$emit('input', e)
    }

    handleAction(): void {
        this.$emit('action')
    }

    focus() {
        (this.$refs[this.inputId] as any).focus()
    }

}
